










































































import Vue from 'vue';
import { OutlinedSelect, OutlinedTextInput } from '@descomplica/vue-components';
import ProuniFileUpload from '@/components/forms/prouni/ProuniFileUpload.vue';
import {
  brDateToIso,
  formatCpf,
  formatDateString,
  formatPhoneNumber,
  isoToBrDate,
  onlyDigits,
} from '@/helpers/formatters';
import prouniAuth from '@/helpers/prouniAuth';
import {
  isCpfValid,
  isDateStringValid,
  isEmailValid,
  isMobilePhoneValid,
} from '@/helpers/validators';
import { ProuniApplication, ProuniDocumentType } from '@/store/modules/prouni/types';

export default Vue.extend({
  name: 'ProuniPersonalDataForm',
  components: { OutlinedSelect, OutlinedTextInput, ProuniFileUpload },
  props: {
    application: {
      type: Object as () => ProuniApplication | null,
      default: null,
    },
  },
  data() {
    const app = this.application || {};
    return {
      form: {
        fullName: app.fullName || '',
        cpf: app.cpf || '',
        birthDate: isoToBrDate(app.birthDate),
        gender: app.gender || '',
        email: app.email || prouniAuth.getPocketProfile()?.email || '',
        phone: app.phone || '',
        sisProuniInscriptionNumber: app.sisProuniInscriptionNumber || '',
      },
      masks: {
        cpf: formatCpf,
        date: formatDateString,
        phone: formatPhoneNumber,
        onlyDigits,
      },
      errors: {
        cpf: false,
        birthDate: false,
        email: false,
        phone: false,
      },
      uploaded: {
        inscriptionForm: Boolean(
          (app.documents || []).some(d => d.documentType === ProuniDocumentType.inscriptionForm),
        ),
      },
      documentTypes: ProuniDocumentType,
    };
  },
  computed: {
    genderOptions(): string[] {
      return this.$store.getters.genderOptions || [];
    },
  },
  created() {
    this.$store.dispatch('PULL_GENDER_OPTIONS');
  },
  mounted() {
    // Emit the initial validity so revisiting a step (already filled) enables Continue.
    this.inputHandler();
  },
  methods: {
    setInscriptionDone(done: boolean) {
      this.uploaded.inscriptionForm = done;
      this.inputHandler();
    },
    inputHandler() {
      this.errors.cpf = !!this.form.cpf && !isCpfValid(this.form.cpf);
      this.errors.birthDate = !!this.form.birthDate && !isDateStringValid(this.form.birthDate);
      this.errors.email = !!this.form.email && !isEmailValid(this.form.email);
      this.errors.phone = !!this.form.phone && !isMobilePhoneValid(this.form.phone);

      const filledRequired = [
        this.form.fullName,
        this.form.cpf,
        this.form.birthDate,
        this.form.gender,
        this.form.email,
        this.form.phone,
        this.form.sisProuniInscriptionNumber,
      ].every(Boolean);

      const hasErrors = Object.values(this.errors).some(Boolean);
      const isValid = filledRequired && !hasErrors && this.uploaded.inscriptionForm;

      this.$emit('input', { ...this.form, birthDate: brDateToIso(this.form.birthDate) }, isValid);
    },
  },
});
